/* eslint-disable indent */
import { Component, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { IWarehouseProduct } from '../../../warehouse-products.interface';
import { WarehouseProductService } from '../../../warehouse-products.service';

@Component({
  selector: 'pg-producf-of-warehouse-list',
  templateUrl: './list-warehouse-product.component.html'
})
export class ProductOfWarehouseListComponent {
  @Output('stepsEmitter') stepsEmitter = new EventEmitter<IWarehouseProduct>();
  warehouseSubscription$: Subscription;

  table: {
    settings: ISettingsTable;
    data: IWarehouseProduct[];
    actions: null;
  } = {
    settings: {
      title: '',
      columns: []
    },
    data: [],
    actions: null
  };

  constructor(private warehouseProductService: WarehouseProductService) {}

  ngOnInit() {
    this.table.settings = {
      title: 'Almacén',
      columns: [
        { header: 'Proveedor', field: 'providerName' },
        { header: 'RUC', field: 'providerRuc' },
        { header: 'U.M.', field: 'unitMeasureDescription' },
        {
          header: 'Descripción producto',
          field: 'productOfProviderDescription'
        },
        { header: 'Código producto', field: 'productOfProviderCode' },
        { header: 'Precio adquisición', field: 'purchasePrice' },
        { header: 'Cantidad', field: 'quantity' },
        { header: 'Exp.', field: 'expAt' },
        { header: 'Lote', field: 'lot' }
      ]
    };
    this.table.actions = null;
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.warehouseSubscription$ = this.warehouseProductService
      .getData$()
      .subscribe((data: IWarehouseProduct[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.warehouseSubscription$.unsubscribe();
  }
}
